import {
  Card,
  Heading,
  Image,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function EmptyState({ isCurrentUser }) {
  return (
    <Card className="flex flex-col gap-6 items-center px-5 py-6">
      <Image
        alt=""
        height={270}
        src="/static/images/illustration-no-solutions.webp"
        width={500}
      />

      <Heading className="text-center" level="5" tagName="span">
        {isCurrentUser
          ? "You haven't submitted any solutions yet."
          : 'No solutions submitted yet.'}
      </Heading>

      {isCurrentUser && (
        <LinkWithButtonStyles href="/challenges">
          Browse challenges
        </LinkWithButtonStyles>
      )}
    </Card>
  );
}
